import { AppDefinition } from '../../types/apps';

// These events should match the APP_ACTIONS registry
export const BROWSER_EVENTS = {
  OPEN: 'BROWSER_OPEN',
  NAVIGATE: 'BROWSER_NAVIGATE',
  REFRESH: 'BROWSER_REFRESH',
  GO_BACK: 'BROWSER_GO_BACK',
  GO_FORWARD: 'BROWSER_GO_FORWARD',
  CHANGE_URL: 'BROWSER_CHANGE_URL',
} as const;

export const BrowserAppDefinition: AppDefinition = {
  appId: 'browser',
  name: 'Browser',
  version: '1.0.0',
  description: 'Web browser for accessing websites',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Globe',
    phosphorWeight: 'duotone',
    color: '#0ea5e9',
    metadata: {
      source: 'app',
      appId: 'browser',
      isAppIcon: true
    }
  },
  supportedFileTypes: ['.html', '.htm'],
  events: BROWSER_EVENTS,
  entityTypes: ['BrowserWindow', 'BrowserPage'],
  component: 'BrowserApp',
  requiresProps: false,
  requiresEntity: false,
  isCore: true,
  actions: {}
};
